<main>
    <div class="row no-gutters justify-content-between follow-us">
        <div class="col-lg-4 col-md-4 col-sm-4 col-4">
            <h5>{{ 'footer.Follow Us' | translate }}</h5>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-8 text-right">
            <a href="https://www.facebook.com/NongHyupFinanceCambodia" target="_blank" class="mr-3"><img [src]="baseApiUrl + '/uploads/images/icons/fb_icon.svg'" ></a>
            <a href="https://www.youtube.com/channel/UCW2J0e3h-YSxFY4HZ2Vdapg/featured" target="_blank" class="mr-3"><img [src]="baseApiUrl + '/uploads/images/icons/youtube_icon.svg'" ></a>
            <a href="https://t.me/nonghyupfinancecambodia" target="_blank" class="mr-3"><img [src]="baseApiUrl + '/uploads/images/icons/telegram_icon.svg'" ></a>
            <a href="https://www.linkedin.com/company/11868576/admin/dashboard" class="mr-3" target="_blank"><img [src]="baseApiUrl + '/uploads/images/icons/linkedin_icon.svg'" ></a>
            <a href="https://www.tiktok.com/@nh.finance" class="mr-3" target="_blank"><img style="height: 18px;" [src]="baseApiUrl + '/uploads/images/icons/tiktok_icon.png'"></a>
        </div>
    </div>
    <div class="row no-gutters company-info">
        <div class="col-lg-6 col-md-6 col-sm-6 col-12 sm-mb-0 mb-3" style="padding-right: 100px;">
            <h6>{{ 'footer.Head Office' | translate }}</h6>
            <p>{{ 'footer.Building 388A E1, E2, E3 Preah Monivong Blvd. Corner street 352 Sangkat Boeng Keng Kang Ti Mouy Khan Boeng Keng Kang Phnom Penh.' | translate }}
            </p>
            <p><span><img [src]="baseApiUrl + '/uploads/images/icons/phone_icon.svg'" alt=""></span>023 998 226 / 023 996 023</p>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-12 sm-mb-0 mb-3">
            <h6>{{ 'footer.Complaint / Call Center' | translate }}</h6>
            <p><span><img [src]="baseApiUrl + '/uploads/images/icons/phone_icon.svg'" alt=""></span>1800 207 816 / 017 666 036</p>
            <p><span><img [src]="baseApiUrl + '/uploads/images/icons/email_icon.svg'" alt=""></span>Feedback&#64;nhfinance.com.kh</p>
        </div>
        <div class="col-lg-2 col-sm-2 col-sm-2 col-12 sm-mb-0 mb-3">
            <h6>{{ 'footer.Business Hour' | translate }}</h6>
            <p>{{ 'footer.Monday' | translate }} - {{ 'footer.Friday' | translate }}</p>
            <p>8:00 AM - 5:00PM</p>
        </div>
    </div>
    <div class="row no-gutters copyright">
        <div class="col">
            <p>&copy; 2024 NongHyup Finance. All Rights Reserved.</p>
        </div>
    </div>
</main>